import { pageFolds, parseFoldLayout } from '@messenger/utils'
import type { FoldLayoutSource } from '@messenger/utils'

export type ProofFoldMarks = {
  verticalCenter: boolean
  horizontalCenter: boolean
  /** A trifold page's fold positions, in px from the page's left edge. */
  folds: number[]
}

/**
 * Which fold marks a proof page draws. A trifold, valid or not, marks each of
 * the page's folds (none when its panel widths are invalid, or the page has
 * no page number or width) and never the middle. Any other product draws the
 * middle mark its fold line names; the center margins never add or remove a
 * mark.
 */
export const proofFoldMarksOf = (
  layout: FoldLayoutSource | null | undefined,
  pageNumber?: number | null,
  pageWidth?: number | null,
): ProofFoldMarks => {
  const folds = pageFolds(
    parseFoldLayout(layout),
    pageNumber ?? 0,
    pageWidth ?? 0,
  )
  if (folds.kind !== 'not-trifold') {
    return {
      verticalCenter: false,
      horizontalCenter: false,
      folds: folds.foldMarks,
    }
  }
  const foldLine = layout?.fold_line ?? layout?.foldLine
  return {
    verticalCenter: foldLine === 'vertical-center',
    horizontalCenter: foldLine === 'horizontal-center',
    folds: [],
  }
}
